import React, { useEffect, useState } from "react";
import "./manageCategory.scss";
import TwoBreadcrumb from "../../../components/breadcrumbs/TwoBreadcrumb";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import snackbarStore from "../../../stores/snackbarStore";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";

// Image
import UploadLogoImage from "../../../assets/upload-icon.png";

// Icons
import DeleteIcon from "@mui/icons-material/Delete";
import categoryStore from "../../../stores/categoryStore";
import IOSSwitch from "../../../components/iosSwitch/IOSSwitch";
import sidebarActivePage from "../../../stores/sidebarActivePage";

const ManageCategory = () => {
  const CategoryStore = categoryStore();
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();

  const navigate = useNavigate();
  const [fileName, setFileName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const params = useParams();
  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Category" });
    CategoryStore.clearCategoryForm();
    if (params.categoryID !== undefined) {
      setUpdateData();
    } else {
      setIsLoading(false);
    }
  }, []);

  const setImage = async (files, name) => {
    const res = await CategoryStore.fillCategoryImage({ files, name });
    if (res === false) {
      SnackbarStore.setMassage({
        value: "File is to large. Max file size is 1.5 MB",
      });
      SnackbarStore.setIsOpen({ value: true });
    } else {
      setFileName(files[0].name);
    }
  };

  const HandleClick = async (e) => {
    e.preventDefault();
    var res = false;
    var validation = false;
    if (CategoryStore.categoryForm.categoryName === "") {
      SnackbarStore.setMassage({ value: "Write Category Name" });
      validation = true;
    } else {
      if (
        CategoryStore.categoryForm.isWomenImage === false &&
        CategoryStore.categoryForm.isMenImage === false &&
        CategoryStore.categoryForm.isKidsImage === false
      ) {
        SnackbarStore.setMassage({
          value: "Select at least one category image",
        });
        validation = true;
      }
      if (
        CategoryStore.categoryForm.isWomenImage === true &&
        CategoryStore.categoryForm.categoryImageOfWomen === ""
      ) {
        SnackbarStore.setMassage({ value: "Select Women Category Image" });
        validation = true;
      }
      if (
        CategoryStore.categoryForm.isMenImage === true &&
        CategoryStore.categoryForm.categoryImageOfMen === ""
      ) {
        SnackbarStore.setMassage({ value: "Select Men Category Image" });
        validation = true;
      }
      if (
        CategoryStore.categoryForm.isKidsImage === true &&
        CategoryStore.categoryForm.categoryImageOfKids === ""
      ) {
        SnackbarStore.setMassage({ value: "Select Kids Category Image" });
        validation = true;
      }
    }

    if (validation === true) {
      SnackbarStore.setIsOpen({ value: true });
      return false;
    }

    setIsLoading(true);
    if (params.categoryID !== undefined) {
      res = await CategoryStore.updateCategory();
      SnackbarStore.setMassage({ value: "Update Successfully" });
    } else {
      res = await CategoryStore.createCategory();
      SnackbarStore.setMassage({ value: "The is a Create Successfully" });
    }
    setIsLoading(false);

    if (res) return navigate("/category");
  };

  const setUpdateData = async () => {
    await CategoryStore.fillCategoryId({ value: params.categoryID });
    await CategoryStore.fetchOneCategory();
    setIsLoading(false);
  };

  return (
    <div className="manageCategory w-100">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        alertVariant="filled"
        alertSeverity="error"
        alertColor="error"
        massage={SnackbarStore.massage}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          <div className="heading">
            {params.categoryID !== undefined ? "Edit" : "Create a new category"}
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TwoBreadcrumb
            mainName="Category"
            mainLink="category"
            activeName={
              params.categoryID !== undefined
                ? CategoryStore.categoryForm.categoryName
                : "New Category"
            }
          />
        </Grid>
      </Grid>
      <Grid container className="gridContainer">
        <Grid
          container
          item
          xs={1}
          md={5}
          lg={5}
          display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          className="gridTitles"
        >
          <Grid item xs={12}>
            <h2>Details</h2>
            <p>Title, Image</p>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          sm={12}
          lg={7}
          spacing={3}
          className="gridContent"
          component="form"
        >
          <Grid item xs={12} className="gridContentTitle">
            <h2>Details</h2>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Category Name"
              variant="outlined"
              className="w-100 categoryName"
              name="categoryName"
              value={CategoryStore.categoryForm.categoryName}
              onChange={CategoryStore.fillCategoryName}
            />
          </Grid>
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Women Image {CategoryStore.categoryForm.isWomenImage && "*"}
              <FormControlLabel
                name="isWomenImage"
                checked={CategoryStore.categoryForm.isWomenImage}
                control={<IOSSwitch sx={{ m: 1 }} />}
                onChange={(e) =>
                  CategoryStore.setSwitchOnOrOff({
                    name: e.target.name,
                    value: !CategoryStore.categoryForm.isWomenImage,
                  })
                }
              />
            </Box>

            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() =>
                document.querySelector(".women-input-flied").click()
              }
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              disabled={CategoryStore.categoryForm.isWomenImage ? false : true}
              name="categoryImageOfWomen"
              type="file"
              accept="image/*"
              className="women-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {CategoryStore.imagePreviewOfWomen && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => {
                      setFileName(null);
                      CategoryStore.clearCategoryImage({
                        name: "categoryImageOfWomen",
                      });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={
                        CategoryStore.imagePreviewOfWomen &&
                        CategoryStore.imagePreviewOfWomen
                      }
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {CategoryStore.categoryForm.categoryImageOfWomen &&
                    CategoryStore.categoryForm.categoryImageOfWomen.name
                      ? CategoryStore.categoryForm.categoryImageOfWomen.name
                      : CategoryStore.categoryForm.categoryImageOfWomen}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Men Image {CategoryStore.categoryForm.isMenImage && "*"}
              <FormControlLabel
                name="isMenImage"
                checked={CategoryStore.categoryForm.isMenImage}
                control={<IOSSwitch sx={{ m: 1 }} />}
                onChange={(e) =>
                  CategoryStore.setSwitchOnOrOff({
                    name: e.target.name,
                    value: !CategoryStore.categoryForm.isMenImage,
                  })
                }
              />
            </Box>
            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() => document.querySelector(".men-input-flied").click()}
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              disabled={CategoryStore.categoryForm.isMenImage ? false : true}
              name="categoryImageOfMen"
              type="file"
              accept="image/*"
              className="men-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {CategoryStore.imagePreviewOfMen && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => {
                      setFileName(null);
                      CategoryStore.clearCategoryImage({
                        name: "categoryImageOfMen",
                      });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={
                        CategoryStore.imagePreviewOfMen &&
                        CategoryStore.imagePreviewOfMen
                      }
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {CategoryStore.categoryForm.categoryImageOfMen &&
                    CategoryStore.categoryForm.categoryImageOfMen.name
                      ? CategoryStore.categoryForm.categoryImageOfMen.name
                      : CategoryStore.categoryForm.categoryImageOfMen}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Kids Image {CategoryStore.categoryForm.isKidsImage && "*"}
              <FormControlLabel
                name="isKidsImage"
                checked={CategoryStore.categoryForm.isKidsImage}
                control={<IOSSwitch sx={{ m: 1 }} />}
                onChange={(e) =>
                  CategoryStore.setSwitchOnOrOff({
                    name: e.target.name,
                    value: !CategoryStore.categoryForm.isKidsImage,
                  })
                }
              />
            </Box>
            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() =>
                document.querySelector(".kids-input-flied").click()
              }
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              disabled={CategoryStore.categoryForm.isKidsImage ? false : true}
              name="categoryImageOfKids"
              type="file"
              accept="image/*"
              className="kids-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {CategoryStore.imagePreviewOfKids && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => {
                      setFileName(null);
                      CategoryStore.clearCategoryImage({
                        name: "categoryImageOfKids",
                      });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={
                        CategoryStore.imagePreviewOfKids &&
                        CategoryStore.imagePreviewOfKids
                      }
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {CategoryStore.categoryForm.categoryImageOfKids &&
                    CategoryStore.categoryForm.categoryImageOfKids.name
                      ? CategoryStore.categoryForm.categoryImageOfKids.name
                      : CategoryStore.categoryForm.categoryImageOfKids}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid container item xs={12} mt="20px">
          <Grid
            container
            item
            xs={0}
            md={5}
            lg={5}
            display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          ></Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            sm={12}
            lg={7}
            sx={{ justifyContent: "flex-end" }}
            className="btnContainer"
          >
            <Button variant="contained" className="btn" onClick={HandleClick}>
              {params.categoryID !== undefined
                ? "Save Changes"
                : "Create Category"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ManageCategory;
